var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1295 1.32258L22.0662 9.81245C22.6624 10.3788 23 11.1651 23 11.9874V20.6288C23 22.0095 21.8807 23.1288 20.5 23.1288H14.5C13.9477 23.1288 13.5 22.6811 13.5 22.1288V16.6287C13.5 15.8003 12.8284 15.1287 12 15.1287C11.1716 15.1287 10.5 15.8003 10.5 16.6287V22.1288C10.5 22.6811 10.0523 23.1288 9.5 23.1288H3.5C2.11929 23.1288 1 22.0095 1 20.6288V11.9874C1 11.1651 1.33756 10.3788 1.93375 9.81245L10.8705 1.32258C11.5034 0.721248 12.4966 0.721248 13.1295 1.32258Z",
    fill: "#322267"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperts);
export default __webpack_public_path__ + "static/media/experts.1a1829e98e6abe328d2e2978d44e6990.svg";
export { ForwardRef as ReactComponent };